import React from 'react'; 
import MovieTimes from './MovieTimes';
import getData from '../functions/getData'
import { CLI, FRONT, TRANSLATION } from '../constants/state'
import { compose } from 'redux';
import { connect } from 'react-redux';
import toJS from '../hoc/toJS';
import hasPerformancePerCinemaFilter from '../hoc/hasPerformancePerCinemaFilter';
import { MULTICINEMA } from '../constants/multiCinemaModes';
import { useState } from 'react';
import getFullyFilteredPerformances from '../functions/getFullyFilteredPerformances';
import checkPerformanceFilterIsSet from '../functions/checkPerformanceFilterIsSet';


const mapStateToProps = (state, ownProps) => ({
    cinemaDataFront: getData(state, FRONT),
    translation: getData(state, TRANSLATION),
    cliData: getData(state, CLI)
})

const MovieTimesContainer = ({
    movieData, 
    currentDateActive, 
    filterType, 
    filterValue, 
    activePerformance, 
    scrollToPosition, 
    onClick,   
    dayFilters,
    additionalClass = '', 
    onOpenIframe, 
    overviewFilterIgnoreOnPerformances,
    queryStringValues, 
    translation, 
    performancePageMovieTimes=false, 
    activeCinema,
    cinemas,
    cliData,
    currentCinemaPk,
    setActiveCinema,
    hideCinemaSelector=false,
    cinemaDataFront
}) => {

    const {
        movie_times_desktop,
        movie_times_mobile
    } = cinemaDataFront

    const {
        clusterCinemaName,
        clusterCinemas,
        clusterCinemaOption,
        currentCinemaId
    } = cliData

    const {performances, technologyAttributes} = movieData

    if(!cinemas) {
        return ''
    }

    const [movieTimesOpen, toggleShowtimes] = useState(false)
    const currentCinemaType = cinemas[currentCinemaId] ? cinemas[currentCinemaId].scope.type : null
    const clusterCinemaActive = (clusterCinemaOption || currentCinemaType === MULTICINEMA) && currentCinemaPk === activeCinema ? true : false
    const {purchaseblePerformances, fullyfilteredPerformance} = getFullyFilteredPerformances(performances, activeCinema, technologyAttributes, queryStringValues, filterType, filterValue, overviewFilterIgnoreOnPerformances, dayFilters)
    const performanceFilterIsSet = checkPerformanceFilterIsSet(technologyAttributes, filterType, filterValue, queryStringValues)



        return <MovieTimes
            movieData={movieData} 
            currentDateActive={currentDateActive} 
            activePerformance={activePerformance} 
            scrollToPosition={scrollToPosition} 
            onClick={onClick}   
            additionalClass={additionalClass} 
            fullyfilteredPerformance={fullyfilteredPerformance}
            toggleShowtimes={() => toggleShowtimes(!movieTimesOpen)}
            purchaseblePerformances={purchaseblePerformances}
            movieTimesOpen={movieTimesOpen}
            onOpenIframe={onOpenIframe} 
            movieTimesDesktop={movie_times_desktop} 
            movieTimesMobile={movie_times_mobile} 
            performanceFilterIsSet={performanceFilterIsSet}
            queryStringValues={queryStringValues} 
            currentCinemaType={currentCinemaType}
            translation={translation} 
            performancePageMovieTimes={performancePageMovieTimes}
            activeCinema={activeCinema}
            clusterCinemaOption={clusterCinemaOption}
            clusterCinemaName={clusterCinemaName}
            clusterCinemaActive={clusterCinemaActive}
            clusterCinemas={clusterCinemas}
            cinemas={cinemas}
            currentCinemaPk={currentCinemaPk}
            setActiveCinema={setActiveCinema}
            hideCinemaSelector={hideCinemaSelector}
        />
    }
// } 

export default compose(
    connect(mapStateToProps, null),
    toJS()
)(hasPerformancePerCinemaFilter(MovieTimesContainer))